import { TabProps } from '@opendoor/bricks/core';
import { useTabStyles } from '@opendoor/bricks/core/Tab';

import { LegacyInternalLink, LegacyInternalLinkProps } from 'platform/remix-run/react';

export type TabLinkProps = Omit<LegacyInternalLinkProps, keyof TabProps> &
  // Internal links use the react-router-dom `to` prop
  Omit<TabProps, 'href'>;

/**
 * Styled React Router DOM Link component. Used for nav links that should display as tabs.
 */
export const TabLink: React.FC<TabLinkProps> = ({ variant, isActive, ...props }) => {
  const { styles, className } = useTabStyles({ variant, isActive, ...props });
  return (
    <LegacyInternalLink
      __css={styles}
      className={className}
      aria-current={isActive ? 'page' : undefined}
      {...props}
    />
  );
};
